import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Nav } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import * as yup from 'yup';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { deleteBannerItem } from '../../api/context/banner';
import toast from 'react-hot-toast'
import imageToBase64 from 'image-to-base64/browser';
import { checkUserPermissions } from '../../helpers/permission';
import CreateBrand from './CreateBrand';
import { createBrand, deleteBrandCategory, deleteBrandItem, editBrand, fetchAllBrandAdmin, getBrandDetails, getBrandListing } from '../../api/context/brand';
import { getCategoryListingPaginate, getSubCategoryListingPaginate } from '../../api/context/manufacturer';
import { IoSearchOutline } from 'react-icons/io5';
import { components } from 'react-select'
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { createSizeChart } from '../../api/context/sizechart';
import { FiPlus, FiTrash2, FiEdit2 } from 'react-icons/fi';

const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '700',
            fontSize: '15px',
            color: '#0f172a',
            minHeight: '48px',
            padding: '8px 14px',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            minHeight: '48px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    headCells: {
        style: {
            display: 'flex',
            justifyContent: 'center',
            fontWeight: '600',
            fontSize: '9px',
            padding: '10px 14px',
            color: '#475569',
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
            backgroundColor: '#f8fafc',
        },
    },
    cells: {
        style: {
            display: 'flex',
            fontSize: '10px',
            fontWeight: '500',
            color: '#0f172a',
            padding: '10px 14px',
        },
    },
    rows: {
        style: {
            minHeight: '48px',
            borderBottom: '1px solid #eef2f7',
            paddingLeft: '8px',
            paddingRight: '8px',
            transition: 'background 0.15s ease',
            '&:not(:last-of-type)': { borderBottom: '1px solid #eef2f7' },
            '&:hover': { backgroundColor: '#f8fafc !important', cursor: 'pointer' },
        },
    },
    pagination: {
        style: {
            borderTop: '1px solid #eef2f7',
            minHeight: '52px',
            fontSize: '12px',
            color: '#475569',
        },
    },
};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
    }),
};

// Renders a brand's thumbnail; falls back to the first letter of the brand name
// when the image is missing OR when the URL fails to load.
const BrandImageCell = ({ name, image, onPreview, size = 34, radius = 4, fontSize = 13 }) => {
    const [errored, setErrored] = useState(false);
    const showImage = Boolean(image) && !errored;
    const initial = (name || '').trim().charAt(0).toUpperCase() || '?';
    return (
        <div
            onClick={(e) => { e.stopPropagation(); if (showImage) onPreview?.(image); }}
            style={{
                width: size,
                height: size,
                borderRadius: radius,
                overflow: 'hidden',
                background: showImage ? '#f8fafc' : '#f1f5f9',
                border: '1px solid #e2e8f0',
                color: '#64748b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                cursor: showImage ? 'pointer' : 'default',
                fontSize,
                fontWeight: 700,
                letterSpacing: '-0.01em',
            }}
        >
            {showImage ? (
                <img
                    src={image}
                    alt={name || ''}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setErrored(true)}
                />
            ) : (
                initial
            )}
        </div>
    );
};



const Brand = () => {

    const navigate = useNavigate()

    const [sizeChartData, setSizeChartData] = useState({});
    const [sizeChartMeta, setSizeChartMeta] = useState({
        sizes: [],
        sizeTypes: []
    });
    const [isSavingSizeChart, setIsSavingSizeChart] = useState(false);
    const [showSizeChartModal, setShowSizeChartModal] = useState(false);
    const [show, setShow] = useState(false);
    const [brand, setBrand] = useState([]);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);
    const [isFocusedStaff, setIsFocusedStaff] = useState(false);
    const [filterState, setFilterState] = useState([{
        categories: [
            {
                categoryId: '',
                subCategories: [],
            },
        ],
    }])

    const handleShowImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }


    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: 'Image',
            center: true,
            minWidth: '60px',
            grow: 0,
            cell: (row) => (
                <BrandImageCell
                    name={row?.name}
                    image={row?.image}
                    onPreview={handleShowImage}
                />
            ),
        },
        {
            id: 'title',
            name: 'Brand Name',
            selector: (row) => row?.name,
            cell: (row) => (
                <Tooltip title={row?.name} disableInteractive placement="top">
                    <div
                        onClick={(e) => { e.stopPropagation(); navigate('/edit-brand-page/' + row.id); }}
                        style={{
                            fontSize: 10,
                            fontWeight: 500,
                            color: '#0f172a',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            minWidth: 0,
                            width: '100%',
                            textAlign: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        {row?.name}
                    </div>
                </Tooltip>
            ),
            minWidth: '140px',
            grow: 1,
            center: true
        },
        {
            id: 'createdAt',
            name: 'Created',
            selector: (row) => row?.createdAt,
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
                    <span style={{ fontSize: 10, color: '#475569', whiteSpace: 'nowrap' }}>
                        {moment(row?.createdAt).format('DD MMM YY')}
                    </span>
                </Tooltip>
            ),
            minWidth: '110px',
            grow: 1,
            center: true
        },
        {
            id: 'updatedAt',
            name: 'Updated',
            selector: (row) => row?.updatedAt,
            cell: (row) => (
                <Tooltip title={moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
                    <span style={{ fontSize: 10, color: '#475569', whiteSpace: 'nowrap' }}>
                        {moment(row?.updatedAt).format('DD MMM YY')}
                    </span>
                </Tooltip>
            ),
            minWidth: '110px',
            grow: 1,
            center: true
        },
        {
            id: "action",
            name: "Actions",
            cell: (row) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={(e) => e.stopPropagation()}>
                    <Tooltip title="Edit" disableInteractive placement="top">
                        <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); navigate('/edit-brand-page/' + row.id); }}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 24,
                                height: 24,
                                borderRadius: 6,
                                border: '1px solid #cbd5e1',
                                background: '#f8fafc',
                                color: '#475569',
                                cursor: 'pointer',
                                padding: 0,
                                transition: 'all 0.15s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#475569'; }}
                        >
                            <FiEdit2 size={11} />
                        </button>
                    </Tooltip>
                    <Tooltip title="Delete" disableInteractive placement="top">
                        <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 24,
                                height: 24,
                                borderRadius: 6,
                                border: '1px solid #fecaca',
                                background: '#fef2f2',
                                color: '#dc2626',
                                cursor: 'pointer',
                                padding: 0,
                                transition: 'all 0.15s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#fee2e2'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = '#fef2f2'; }}
                        >
                            <FiTrash2 size={12} />
                        </button>
                    </Tooltip>
                </div>
            ),
            center: true,
            minWidth: '90px',
            grow: 0,
        }
    ];

    const validationSchema = yup.object().shape({
        name: Yup.string()
            .required('Required'),
        image: selectedBrand?.id ? yup.string().nullable() : yup.string().required('Image is required'),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            image: '',
            image_view: '',
            categories: [
                {
                    categoryId: '',
                    subCategories: [],
                },
            ],
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {}

            return errors
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.image == '') {
                delete values.image;
            }
            delete values.image_view;

            // Build sizeChartValues
            const sizeChartPayload = buildSizeChartPayload(sizeChartData, sizeChartMeta);
            const sizeChartValues = sizeChartPayload.values;


            const payload = {
                ...values,
                sizeChartValues,
            };
            console.log('payload when saving brand', payload);

            if (selectedBrand?.id) {
                editBrand(payload)((response) => {
                    if (response && response?.data?.statusCode == 200) {

                        resetForm();
                        toast.success("Brand Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedBrand(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createBrand(payload)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Brand Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedBrand(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }

        },
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedBrand(null)
    };

    const fetchBrandData = async () => {
        fetchAllBrandAdmin({ page: page, pageSize: limit, search })((response) => {
            if (response?.statusCode === 200) {
                setBrand(response?.data);
                setTotalRows(response?.totalRecords);
                setLoading(false);
            } else {
                setBrand([]);
                setLoading(false);
            }
        });
    };

    // Fetch categories dynamically based on input
    const loadOptionsCategory = (inputValue) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2) {
                    getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })((response) => {
                        if (response?.statusCode === 200) {
                            resolve(response?.results);
                            setCategory(response?.results);
                        } else {
                            resolve([]);
                        }
                    });
                } else {
                    resolve([]);
                    setCategory([]);
                    setSubCategory([]);
                }
            }, 300);
        });
    };

    let typingTimer;
    // Fetch subcategories based on category ID
    const loadOptionsSubCategory = (inputValue, categoryId) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2 && categoryId) {
                    getSubCategoryListingPaginate({
                        page: 1,
                        pageSize: 10,
                        search: inputValue,
                        categoryIds: [categoryId],
                    })((response) => {
                        if (response?.statusCode === 200) {
                            resolve(response?.results);
                            setSubCategory(response?.results);
                        } else {
                            resolve([]);
                        }
                    });
                } else {
                    resolve([]);
                    setSubCategory([]);
                }
            }, 300);
        });
    };

    // Handling category change
    const onCategoryChange = (selectedOption, index) => {
        const updatedCategories = [...formik.values.categories];
        updatedCategories[index] = {
            ...updatedCategories[index],
            categoryId: selectedOption ? selectedOption.value : '',
            selectedCategory: selectedOption,
            subCategories: [], // Reset subcategories when category changes
        };
        formik.setFieldValue('categories', updatedCategories);

    };

    // Handling subcategory change
    const onSubCategoryChange = (selectedOption, index) => {
        const updatedCategories = [...formik.values.categories];
        updatedCategories[index] = {
            ...updatedCategories[index],
            subCategories: selectedOption ? selectedOption.map((opt) => opt.value) : [],
            selectedSubCategory: selectedOption,
        };
        formik.setFieldValue('categories', updatedCategories);
    };

    const handleCategoryAdd = () => {
        const newCategory = {
            categoryId: '',
            subCategories: [],
            selectedCategory: null,
            selectedSubCategory: [],
        };

        formik.setFieldValue('categories', [
            ...formik.values.categories,
            newCategory,
        ]);
    };

    const onhandleChangeCategory = (categoryId) => {

        getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: [categoryId] })(response => {
            if (response?.statusCode == 200) {
                setSubCategory(response?.results)
            } else {
                setSubCategory([])
            }
        })
    }


    const handleEditClick = (brand) => {
        setSelectedBrand(brand);
        setShow(true);
        setModalLoading(true);

        getBrandDetails({ id: brand?.id })(response => {
            setModalLoading(false);

            if (response && response.data?.statusCode === 200) {
                const brandData = response?.data?.data;

                // Transform the API data to match your form structure
                const transformedCategories = brandData.BrandCategories.map(item => ({
                    categoryId: item.categoryId,
                    subCategories: [item.subCategoryId], // Assuming single subcategory per category
                    selectedCategory: {
                        value: item.categoryId,
                        label: item.category.title
                    },
                    selectedSubCategory: [{
                        value: item.subCategoryId,
                        label: item.subcategory.title
                    }]
                }));

                formik.setValues({
                    id: brandData.id,
                    name: brandData.name,
                    image_view: brandData.image,
                    categories: transformedCategories
                });
            } else {
                console.error('Failed to fetch brand details:', response);
            }
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };





    const deleteBrand = (id) => {
        setLoading(true);
        deleteBrandItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Brand deleted successfully")
            } else {
            }
        });
        // });
    };


    useEffect(() => {
        setLoading(true);
        fetchBrandData();
    }, [update]);


    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) setUpdate(!update);
            else setInitial(!initial);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    useEffect(() => {

        getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                setCategory(response?.results)
            } else {
                setCategory([])
            }
        })

    }, []);



    const customNoOptionsMessage = ({ inputValue }) => {
        return inputValue.length < 2
            ? "Please type atleast 2 characters"
            : "No options";
    };

    const deleteCategory = (brandId, categoryId) => {
        deleteBrandCategory(brandId, categoryId)((response) => {
            if (response?.data?.statusCode == 200) {
                // setUpdate(!update);
            } else {

            }
        });

    }

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {filterState && filterState[state] && filterState[state].length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}



            </components.DropdownIndicator>
        );
    };


    const buildSizeChartPayload = (sizeChartData, sizeChartMeta) => {
        const values = [];
        Object.entries(sizeChartData).forEach(([categoryId, subCats]) => {
            Object.entries(subCats).forEach(([subCategoryId, sizesObj]) => {
                const sizes = [];
                Object.entries(sizesObj).forEach(([sizeLabel, typeObj]) => {
                    Object.entries(typeObj).forEach(([typeLabel, measurement]) => {
                        const size = sizeChartMeta.sizes.find(
                            s => s.size === sizeLabel && String(s.subsubcategoryId) === String(subCategoryId)
                        );
                        const type = sizeChartMeta.sizeTypes.find(
                            t => t.sizeType === typeLabel && String(t.subsubcategoryId) === String(subCategoryId)
                        );
                        if (size && type && measurement !== "") {
                            sizes.push({
                                subsubCategorySizeId: size.id,
                                subsubCategorySizeTypeId: type.id,
                                measurement: Number(measurement),
                                unit: size.unit || "cm"
                            });
                        }
                    });
                });
                if (sizes.length > 0) {
                    values.push({
                        categoryId: Number(categoryId),
                        subCategoryId: Number(subCategoryId),
                        sizes
                    });
                }
            });
        });
        return {
            values
        };
    };


    return (
        <>
            <div className="brand-page">
                <style>{`
                  /* Match homepage/Inventory: soft neutral background + consistent 16px horizontal gutter.
                     These rules cancel the parent layout's default padding so the sticky header's
                     "margin: 0 -16px" actually bleeds edge-to-edge instead of leaving extra space. */
                  .brand-page { background: #f9fafb; min-height: calc(100vh - 70px); }
                  .main-content:has(.brand-page) { background: #f9fafb; }
                  .page-content:has(.brand-page) { background: #f9fafb; }
                  body:has(.brand-page) .container-fluid,
                  body:has(.brand-page) .container {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                  }
                  body:has(.brand-page) .page-content,
                  body:has(.brand-page) #layout-wrapper.no-topbar .page-content,
                  body:has(.brand-page) #layout-wrapper .page-content {
                    padding-top: 0 !important;
                    padding-bottom: 24px !important;
                    padding-left: 16px !important;
                    padding-right: 16px !important;
                  }
                  .brand-page h3 { font-size: 18px !important; }
                  .brand-page h4 { font-size: 16px !important; }
                  .brand-page h5 { font-size: 14px !important; }
                  .brand-page h6 { font-size: 12px !important; }
                  .brand-page p  { font-size: 12px; }
                  .brand-page .small,
                  .brand-page small { font-size: 11px !important; }
                  .brand-page .badge { font-size: 10px !important; padding: 3px 7px !important; }
                  .brand-page .btn { font-size: 12px; }
                  .brand-page .row { margin-bottom: 0; }
                  .brand-page .products-and-options .MuiPaper-root {
                    border: 1px solid #e2e8f0 !important;
                    border-radius: 10px !important;
                    overflow: hidden;
                  }

                  /* Sticky header — bleeds edge-to-edge */
                  .brand-page .page-header-sticky {
                    padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
                    margin: 0 -16px 16px !important;
                    top: 0 !important;
                    background: #f9fafb !important;
                    border-bottom: 1px solid #eef2f7 !important;
                    box-shadow: none !important;
                  }
                  @media (max-width: 991px) {
                    .brand-page .page-header-sticky { padding: 16px 16px 12px !important; }
                  }
                  @media (max-width: 767.98px) {
                    .brand-page .page-header-sticky {
                      padding: 10px 16px 8px !important;
                      margin: 0 -16px 8px !important;
                      position: static !important;
                    }
                  }
                  @media (max-width: 480px) {
                    .brand-page .page-header-sticky {
                      padding: 10px 16px 8px !important;
                      margin: 0 -16px 8px !important;
                    }
                  }

                  /* Header actions */
                  .brand-page .brand-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 6px 22px !important;
                    border-radius: 4px !important;
                    font-size: 12px !important;
                    font-weight: 500 !important;
                    height: 34px;
                    white-space: nowrap;
                    transition: all 0.15s ease;
                    border: 1px solid #e2e8f0;
                    background: #fff;
                    color: #475569;
                    cursor: pointer;
                  }
                  .brand-page .brand-btn:hover {
                    border-color: #008695;
                    color: #008695;
                    background: rgba(0,134,149,0.06);
                  }
                  .brand-page .brand-btn-primary {
                    background: #008695 !important;
                    border-color: #008695 !important;
                    color: #fff !important;
                  }
                  .brand-page .brand-btn-primary:hover {
                    background: #006672 !important;
                    border-color: #006672 !important;
                    color: #fff !important;
                  }
                  .brand-page .brand-btn svg { width: 14px; height: 14px; }

                  /* Search row + input */
                  .brand-page .brand-search-row { margin: 12px 0 !important; padding: 0; }
                  @media (max-width: 767.98px) {
                    .brand-page .brand-search-row { margin: 0 0 8px !important; }
                  }
                  .brand-page .brand-search-input {
                    border: 1px solid #e2e8f0 !important;
                    border-radius: 4px !important;
                    padding: 6px 12px !important;
                    font-size: 12px !important;
                    height: 34px !important;
                    background: #fff !important;
                    color: #0f172a !important;
                  }
                  .brand-page .brand-search-input:focus {
                    border-color: #008695 !important;
                    box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                    outline: none;
                  }

                  /* Empty state */
                  .brand-page .brand-empty {
                    width: 100%;
                    min-height: 340px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 32px 20px;
                    text-align: center;
                    color: #64748b;
                    background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
                  }
                  .brand-page .brand-empty-icon {
                    font-size: 40px;
                    margin-bottom: 12px;
                    opacity: 0.7;
                    filter: grayscale(0.2);
                  }
                  .brand-page .brand-empty-title {
                    font-size: 15px;
                    font-weight: 700;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                    margin: 0 0 4px;
                  }
                  .brand-page .brand-empty-sub {
                    font-size: 12px;
                    color: #94a3b8;
                    font-weight: 500;
                    margin: 0;
                  }

                  /* Table container */
                  .brand-page .products-and-options { padding: 0; }

                  /* Mobile card list + fixed pagination (hidden on desktop) */
                  .brand-page .brand-mobile-list { display: none; }
                  .brand-page .brand-mobile-loading { min-height: 40vh; display: flex; align-items: center; justify-content: center; }
                  .brand-page .brand-mobile-pagination { display: none; }

                  /* Mobile responsive — table hides, card list shows */
                  @media (max-width: 767.98px) {
                    .brand-page .page-header-sticky > .d-flex {
                      flex-wrap: nowrap !important;
                      gap: 6px !important;
                    }
                    .brand-page .page-header-sticky > .d-flex > h3 {
                      min-width: 0;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    .brand-page .brand-header-actions {
                      gap: 6px !important;
                      flex-wrap: nowrap !important;
                      flex-shrink: 0;
                    }
                    .brand-page .brand-header-actions .brand-btn {
                      width: 34px;
                      padding: 0 !important;
                      justify-content: center;
                    }
                    .brand-page .brand-header-actions .brand-btn .brand-btn-label { display: none; }

                    /* Hide the DataTable, show the card list */
                    .brand-page .brand-desktop-table { display: none !important; }
                    .brand-page .brand-mobile-list {
                      display: block;
                      /* Leave room for the fixed bottom pagination bar */
                      padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
                    }

                    /* Fixed bottom pagination bar */
                    .brand-page .brand-mobile-pagination {
                      display: flex !important;
                      position: fixed;
                      left: 0; right: 0; bottom: 0;
                      padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
                      background: #fff;
                      border-top: 1px solid #e2e8f0;
                      box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                      z-index: 1049;
                      align-items: center;
                      justify-content: space-between;
                      gap: 10px;
                    }
                    .brand-page .bmp-btn {
                      width: 40px; height: 36px;
                      border-radius: 6px;
                      border: 1px solid #e2e8f0;
                      background: #fff;
                      color: #0f172a;
                      font-size: 16px;
                      font-weight: 700;
                      cursor: pointer;
                      display: inline-flex; align-items: center; justify-content: center;
                      transition: all 0.15s ease;
                    }
                    .brand-page .bmp-btn:hover:not(:disabled) {
                      border-color: #008695;
                      color: #008695;
                      background: rgba(0,134,149,0.06);
                    }
                    .brand-page .bmp-btn:disabled { opacity: 0.35; cursor: not-allowed; }
                    .brand-page .bmp-info {
                      font-size: 11px;
                      color: #475569;
                      display: inline-flex;
                      align-items: baseline;
                      gap: 4px;
                      flex: 1;
                      justify-content: center;
                      text-align: center;
                    }
                    .brand-page .bmp-info strong { color: #008695; font-weight: 700; }
                    .brand-page .bmp-total { color: #94a3b8; font-size: 10px; }
                  }

                  /* Card layout */
                  .brand-page .brand-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 10px 12px;
                    margin-bottom: 8px;
                    box-shadow: 0 1px 2px rgba(15,23,42,0.03);
                    cursor: pointer;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
                  }
                  .brand-page .brand-card:active {
                    transform: scale(0.995);
                  }
                  .brand-page .brand-card:hover {
                    border-color: #cbd5e1;
                    box-shadow: 0 2px 6px rgba(15,23,42,0.06);
                  }
                  .brand-page .brand-card-content {
                    flex: 1;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                  }
                  .brand-page .brand-card-name {
                    font-size: 13px;
                    font-weight: 600;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .brand-page .brand-card-meta {
                    font-size: 10.5px;
                    font-weight: 500;
                    color: #94a3b8;
                  }
                  .brand-page .brand-card-actions {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    flex-shrink: 0;
                  }
                  .brand-page .brand-card-action-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    border-radius: 6px;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    color: #475569;
                    cursor: pointer;
                    padding: 0;
                    transition: all 0.15s ease;
                  }
                  .brand-page .brand-card-action-btn.is-danger {
                    background: #fef2f2;
                    border-color: #fecaca;
                    color: #dc2626;
                  }

                  /* Delete-confirm modal */
                  .brand-delete-modal { max-width: 380px; }
                  .brand-delete-modal-content {
                    border: none !important;
                    border-radius: 14px !important;
                    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18) !important;
                    overflow: hidden !important;
                  }
                  @media (max-width: 480px) {
                    .brand-delete-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
                  }
                `}</style>

                <div className="page-header-sticky">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.01em' }}>Brands</h3>

                        <div className="brand-header-actions d-flex align-items-center gap-2 flex-wrap">
                            <button
                                type="button"
                                className="brand-btn brand-btn-primary"
                                onClick={() => navigate('/edit-brand-page/')}
                                title="Add Brand"
                            >
                                <FiPlus strokeWidth={2.5} />
                                <span className="brand-btn-label">Add Brand</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Search — outside sticky header, matches inventory pattern */}
                <div className="brand-search-row d-flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div style={{ flex: 1, minWidth: '220px' }}>
                        <Form.Control
                            type="text"
                            className="brand-search-input"
                            placeholder="Search for brands..."
                            onChange={(e) => setSearch(e.target.value.trim())}
                        />
                    </div>
                </div>

                <div className='col-12 brand-desktop-table'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border border-blue-grey-200'>
                            <div>
                                <DataTable
                                    pointerOnHover
                                    highlightOnHover
                                    columns={columns}
                                    data={brand}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onRowClicked={(row) => navigate('/edit-brand-page/' + row.id)}
                                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                    noDataComponent={
                                        <div className="brand-empty">
                                            <div className="brand-empty-icon" aria-hidden="true">🏷️</div>
                                            <div className="brand-empty-title">No brands found</div>
                                            <div className="brand-empty-sub">Try adjusting your search or add a new brand.</div>
                                        </div>
                                    }
                                />
                            </div>
                        </Paper>
                    </Box>
                </div>

                {/* Mobile card list */}
                <div className="brand-mobile-list">
                    {loading ? (
                        <div className="brand-mobile-loading"><Loader /></div>
                    ) : brand && brand.length > 0 ? (
                        brand.map((row) => (
                            <div
                                key={row.id}
                                className="brand-card"
                                onClick={() => navigate('/edit-brand-page/' + row.id)}
                            >
                                <BrandImageCell
                                    name={row?.name}
                                    image={row?.image}
                                    onPreview={handleShowImage}
                                    size={52}
                                    radius={8}
                                    fontSize={20}
                                />
                                <div className="brand-card-content">
                                    <div className="brand-card-name">{row?.name}</div>
                                    <div className="brand-card-meta">
                                        Updated {moment(row?.updatedAt).format('DD MMM YY')}
                                    </div>
                                </div>
                                <div className="brand-card-actions">
                                    <button
                                        type="button"
                                        aria-label="Edit brand"
                                        className="brand-card-action-btn"
                                        onClick={(e) => { e.stopPropagation(); navigate('/edit-brand-page/' + row.id); }}
                                    >
                                        <FiEdit2 size={13} />
                                    </button>
                                    <button
                                        type="button"
                                        aria-label="Delete brand"
                                        className="brand-card-action-btn is-danger"
                                        onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                                    >
                                        <FiTrash2 size={14} />
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="brand-empty">
                            <div className="brand-empty-icon" aria-hidden="true">🏷️</div>
                            <div className="brand-empty-title">No brands found</div>
                            <div className="brand-empty-sub">Try adjusting your search or add a new brand.</div>
                        </div>
                    )}
                </div>

                {/* Mobile-only fixed pagination bar */}
                {(() => {
                    const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
                    const canPrev = page > 1;
                    const canNext = page < totalPages;
                    return (
                        <div className="brand-mobile-pagination">
                            <button
                                type="button"
                                className="bmp-btn"
                                onClick={() => canPrev && handlePageChange(page - 1)}
                                disabled={!canPrev}
                                aria-label="Previous page"
                            >
                                ←
                            </button>
                            <span className="bmp-info">
                                Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                                <span className="bmp-total">· {totalRows || 0} brands</span>
                            </span>
                            <button
                                type="button"
                                className="bmp-btn"
                                onClick={() => canNext && handlePageChange(page + 1)}
                                disabled={!canNext}
                                aria-label="Next page"
                            >
                                →
                            </button>
                        </div>
                    );
                })()}

                <Modal
                    show={modal}
                    onHide={() => !loading && setModal(false)}
                    centered
                    backdrop={loading ? 'static' : true}
                    keyboard={!loading}
                    dialogClassName="brand-delete-modal"
                    contentClassName="brand-delete-modal-content"
                >
                    <Modal.Body style={{ padding: '22px 22px 18px', textAlign: 'center' }}>
                        <div
                            style={{
                                width: 52,
                                height: 52,
                                borderRadius: '50%',
                                background: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 12,
                            }}
                        >
                            <FiTrash2 size={22} />
                        </div>
                        <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.01em' }}>
                            Delete brand?
                        </h5>
                        <p style={{ fontSize: 12.5, color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                            This action cannot be undone. The selected brand will be permanently removed.
                        </p>
                    </Modal.Body>
                    <Modal.Footer
                        style={{
                            padding: '12px 18px',
                            borderTop: '1px solid #eef2f7',
                            display: 'flex',
                            gap: 8,
                            justifyContent: 'stretch',
                        }}
                    >
                        <button
                            type="button"
                            onClick={() => setModal(false)}
                            disabled={loading}
                            style={{
                                flex: 1,
                                height: 38,
                                borderRadius: 6,
                                border: '1px solid #e2e8f0',
                                background: '#fff',
                                color: '#0f172a',
                                fontSize: 12.5,
                                fontWeight: 600,
                                cursor: loading ? 'not-allowed' : 'pointer',
                                opacity: loading ? 0.6 : 1,
                                transition: 'all 0.15s ease',
                            }}
                        >
                            No
                        </button>
                        <button
                            type="button"
                            onClick={() => deleteBrand(deletingId)}
                            disabled={loading}
                            style={{
                                flex: 1,
                                height: 38,
                                borderRadius: 6,
                                border: '1px solid #dc2626',
                                background: '#dc2626',
                                color: '#fff',
                                fontSize: 12.5,
                                fontWeight: 600,
                                cursor: loading ? 'not-allowed' : 'pointer',
                                opacity: loading ? 0.85 : 1,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 6,
                                boxShadow: '0 3px 8px rgba(220,38,38,0.22)',
                                transition: 'all 0.15s ease',
                            }}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <FiTrash2 size={13} />
                                    Yes, Delete
                                </>
                            )}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>

            <Modal
                show={showmobimg}
                onHide={handleCloseMobImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={mobimg} alt='' className="img-fluid" />
                </div>
            </Modal>
        </>
    )
}

export default Brand